'use strict';

const forEach = require('lodash/forEach');

const ValidateUtil = {
    // drop in replacement for FormValidateMixin
    getDefaultValidationState: function() {
        return {
            error: null,
            actionSuccess: false,
            successMessage: "",
            uiErrors: {}
        }
    },

    // drop in replacement for FormValidateMixin
    getUpdatedState: function(stateActionId, storeState, retainActionId=false) {
        let actionSuccess = false;
        let successMessage = "";
        let uiErrors = {};
        let error = null;
        let updatedActionId = stateActionId;
        const errorInfo = ValidateUtil.parseError(storeState.action, stateActionId);

        if (errorInfo) {
            if(!retainActionId) {
                updatedActionId = null;
            }
            uiErrors = errorInfo.uiErrors;
            error = errorInfo.error;
            actionSuccess = false;
        }
        else if (ValidateUtil.actionSucceeded(storeState.action, stateActionId)) {
            if(!retainActionId) {
                updatedActionId = null;
            }
            actionSuccess = true;
            successMessage = storeState.action.message || "";
        }

        return {
            uiErrors: uiErrors,
            error: error,
            actionID: updatedActionId,
            actionSuccess: actionSuccess,
            successMessage: successMessage,
        };
    },

    getUpdatedStateFromNextProps(state, nextProps) {
        //this.state.actionID will exist if the action is called from the (child) component
        //nextProps.childActionID exists if the action is called from the parent and passed as a prop
        let newState = {
            componentActID: state.actionID || nextProps.childActionID
        };

        const errorInfo = ValidateUtil.parseError(nextProps.action, newState.componentActID);
        if (errorInfo) {
            newState.componentActID = null,
            newState.error = errorInfo.error;
            newState.uiErrors = errorInfo.uiErrors;

            newState.actionSuccess = false;
            newState.successMessage = "";
        }
        else if (ValidateUtil.actionSucceeded(nextProps.action, newState.componentActID)) {
            newState.componentActID = null;
            newState.actionSuccess = true;
            newState.successMessage = nextProps.action.message || "";

            newState.error = null;
            newState.uiErrors = {};
        }

        return newState;
    },

    // drop in replacement for FormValidateMixin
    getValidationState: function(componentState, uiRef) {
        if (componentState.uiErrors[uiRef]) {
            return 'error';
        }
    },

    // drop in replacement for FormValidateMixin // updated for bs4
    isInvalid: function(componentState, uiRef) {
        if (componentState.uiErrors[uiRef]) {
            return true;
        }
    },

    parseError: function(passedAction, componentActionID) {
        if (!passedAction) return null;

        var uiErrors = {};
        var passedError = !!passedAction.error;
        var notApplicActID = !passedAction.id && !componentActionID;
        var matchingActID = passedAction.id === componentActionID;

        if (passedError && (notApplicActID || matchingActID)) {
            forEach(passedAction.error.uiRefs, function(ref) {
                uiErrors[ref] = true;
            });

            return {
                error: passedAction.error,
                uiErrors: uiErrors
            }
        }

        return null;
    },

    actionSucceeded: function(passedAction, componentActionID) {
        if (!passedAction) return false;

        var passedError = !!passedAction.error;
        var matchingActID = passedAction.id === componentActionID;

        return !passedError && matchingActID;
    }
}

module.exports = ValidateUtil;